import React from 'react';

export default function CareerIcon() {
  return (
    <svg
      role="img"
      aria-labelledby="career-icon-title"
      className="svg-icon"
      width="35px"
      height="35px"
      viewBox="0 0 35 35"
    >
      <title id="career-icon-title">Career Icon</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#19A6A8" fillRule="nonzero">
          <path d="M31.2847125,10.9830468 L26.8867461,10.9830468 L26.8867461,7.5425164 L33.9888675,7.5425164 C33.9893934,7.54224938 33.9896564,7.54224938 33.9901823,7.5425164 C34.5479488,7.5425164 35,7.08320933 35,6.51708666 C35,6.21773596 34.8737728,5.94856066 34.6725982,5.76109932 L32.7129208,3.77112466 L34.7028401,1.75044063 C34.9915849,1.45723178 35.0781031,1.01635045 34.9218969,0.632882384 C34.7654278,0.2499485 34.3972651,0 33.9888675,0 L25.8769285,0 C25.319425,0 24.8671108,0.45904005 24.8671108,1.02542974 L24.8671108,10.9830468 L23.7137096,10.9830468 C21.6659362,10.9830468 20,12.6747389 20,14.7541715 L20,33.9745703 C20,34.54096 20.4523142,35 21.0098177,35 L33.9888675,35 C34.5466339,35 34.9986852,34.54096 34.9986852,33.9745703 L34.9986852,14.7544386 C34.9986852,12.6750059 33.332486,10.9830468 31.2847125,10.9830468 Z" />
          <path d="M0,31 L0,33.9123354 C0,34.5131001 0.505677493,35 1.12961111,35 L5,35 L5,27 L4.15426249,27 C1.86356418,27 0,28.7943634 0,31 Z" />
          <path d="M7,25.7611252 L7,33.9772168 C7,34.5421447 7.50564774,35 8.12954464,35 L12,35 L12,22 L11.1540181,22 C8.86345453,22 7,23.6873258 7,25.7611252 Z" />
          <path d="M13,20.6641921 L13,34.003647 C13,34.5539763 13.5056774,35 14.1293169,35 L18,35 L18,17 L17.1542625,17 C14.8635641,17 13,18.643723 13,20.6641921 Z" />
        </g>
      </g>
    </svg>
  );
}
